import React, {useEffect, useState} from 'react';
import {Button, Card, Col, DatePicker, Divider, Form, Input, Row, Typography} from "antd";
import Tenant from "./Tenant";
import FloatLabel from "../FloatLabel";
import SelectLot from "./SelectLot";
import InputNumberFormated from "./InputNumberFormated";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {addBooking} from "../../store/actions/BookingAction";
import BuildingSelector from "./BuildingSelector";
import {loadLocataires} from "../../store/actions/locataireAction";

const { Title } = Typography;
const initialState = {
	product_id:null,
	building_id:null,
	tenant_id:null, // existant
	tenant:{
		firstname:null,
		lastname:null,
		phone:null,
		email:null,
	}, // nouveau
	start_at:null,
	end_at:null,
	deposit_at:dayjs(),
	deposit_tenant:null,
	deposit_owner:null,
	price:null,
}

export default function BookingComponent({openOptionsTab}) {

	const [selectedLot, setSelectedLot] = useState(null);
	const [values, setValues] = useState(initialState);

	const dispatch = useDispatch();
	/* Rustine : chargement global des locataires */
	const locataires = useSelector(state => state.locataire);
	useEffect(() => {
			dispatch(loadLocataires());
	}, [locataires, dispatch])
	/* ***************************************** */

	const [form] = Form.useForm();

	const handleChange = (changedValues, allValues) => {
		// allValues est déjà un objet { cle: valeur, ... } selon les name
		// Fusionner avec les valeurs existantes pour conserver tenant_id
		setValues(prev => ({
			...prev,
			...allValues
		}));
	};

	const onDateChange = (field) => (date, datestring) => {

		if (field === 'start_at') {
			// Mettre à jour start_at et reporter la même date dans end_at
			form.setFieldsValue({
				//start_at: date,
				end_at: date
			});

			setValues(prev => ({
				...prev,
				//start_at: date,
				end_at: date
			}));
		}
	};

	const handleFinish = async (formValues) => {
		const payload = {
			...formValues,
			tenant_id: values.tenant_id, // Récupéré du state
		};

		await dispatch(addBooking(payload));

		// Réinitialisation du formulaire et du state
		setValues(initialState);
		setSelectedLot(null); // À vérifier
		form.resetFields();

		if (hasVilla() && openOptionsTab) {
			openOptionsTab(); // ouvre/active l’onglet "Options" (28)
		}
	};

	const handleSelection = (value) => {

		if (value.id) {
			const tenantSelected = {
				firstname: value.firstname,
				lastname: value.lastname,
				phone: value.phone || '',
				email: value.email1 || value.email2 || '',
			}

			// Mettre à jour le formulaire
			form.setFieldsValue({
				tenant: tenantSelected
			});

			// Récupérer toutes les valeurs actuelles
			// du formulaire pour synchroniser le state
			const allFormValues = form.getFieldsValue();
			setValues({
				...allFormValues,
				tenant_id: value.id,
				tenant: tenantSelected
			});

		}
	}

	const handleEmailChange = (emailValue) => {
		// Mettre à jour le formulaire
		form.setFieldsValue({
			tenant: {
				...values.tenant,
				email: emailValue
			}
		});

		// Mise à jour de l'email sans sélection de tenant existant
		setValues(prev => ({
			...prev,
			tenant_id: null, // Pas de tenant_id car saisie manuelle
			tenant: {
				...prev.tenant,
				email: emailValue
			}
		}));

	}

	// Selection des villas
	const handleSelectLot = (value) => {
		setSelectedLot(value);
		// Déclencher la validation du champ deposit_owner
		//form.validateFields(['deposit_owner']);

	}

	const handleChangeLot = (value) => {
		//désélectionne l'immeuble
		form.resetFields(['building_id']);

		form.setFieldsValue({product_id: value});
		setValues(prev => ({...prev, product_id: value, building_id: null}));
	}

	const handleChangeBuilding = (value) => {
		// désélectionne la villa
		form.resetFields(['product_id']);
		setSelectedLot(null);

		form.setFieldsValue({building_id: value});
		setValues(prev => ({...prev, building_id: value, product_id: null}));
	}

	const hasVilla = () => {
		const lotType = selectedLot?.type;
		return lotType && (
			lotType.toLowerCase() === 'maison' ||
			lotType.toLowerCase() === 'villa' ||
			lotType.toLowerCase() === 'villas'
		);
	}

	return (
		<div style={{width: "100%", height: "100%", padding: "10px 20px", boxSizing: "border-box"}}>
			<Title style={{margin: 0, color: '#1E2A4A'}} level={2}>Nouvelle réservation</Title>
			<Form
				style={{width:'100%'}}
				form={form}
				onValuesChange={handleChange}
				onFinish={handleFinish}
				initialValues={{
					...initialState,
					deposit_at: dayjs()
				}}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						e.preventDefault(); // empêche le submit
					}
				}}
			>
			<Row gutter={[10, 10]} style={{ margin: '10px 0'}}>
				<Col xs={24} md={12}>
					<Row>
						<Card title="Client" size="small" variant="outlined" style={{width: '100%'}}>
							<Row gutter={[10, 10]}>
								<Col xs={24}>
									<FloatLabel label="Adresse mail" value={values.tenant?.email}>
										<Form.Item
											style={{marginBottom: 0}}
											name={["tenant", "email"]}
											rules={[
												{ required: true, message: "Un Email est obligatoire." },
												{
													type: "email",
													message: "Veuillez saisir un email valide."
												},
												{
													pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
													message: "Le format de l'email est incorrect."
												}
											]}
										>
											<Tenant
												apiEndPoint="search/tenant"
												onSelect={handleSelection}
												onChange={handleEmailChange}
												value={values.tenant?.email}
											/>
										</Form.Item>
									</FloatLabel>
								</Col>
								<Col xs={24}>
									<FloatLabel label="Nom" value={values.tenant?.lastname}>
										<Form.Item
											style={{marginBottom: 0}}
											name={["tenant", "lastname"]}
											rules={[{ required: true, message: "Un nom est obligatoire." }]}
										>
											<Input />
										</Form.Item>
									</FloatLabel>
								</Col>
								<Col xs={24}>
									<FloatLabel label="Prénom" value={values.tenant?.firstname}>
										<Form.Item
											style={{marginBottom: 0}}
											name={["tenant", "firstname"]}
											//rules={[{ required: true, message: "Un prénom est obligatoire." }]}
										>
											<Input />
										</Form.Item>
									</FloatLabel>
								</Col>
								<Col xs={24}>
									<FloatLabel label="Téléphone" value={values.tenant?.phone}>
										<Form.Item
											style={{marginBottom: 0}}
											name={["tenant", "phone"]}
										>
											<Input />
										</Form.Item>
									</FloatLabel>
								</Col>
							</Row>
						</Card>
					</Row>
					<Row>
						<Col span={24} style={{marginTop: 10}}>
							<Card title="Résidence / Villa" size="small" style={{width: '100%'}}>
								<Row gutter={[10, 10]}>
									<Col xs={24}>
										<FloatLabel label="Résidence" value={values.building_id}>
											<Form.Item
												style={{marginRight:0}}
												name="building_id"
												rules={[
													{
														validator: (_, value) => {

															if (!hasVilla()) {
																// Si le type est Maison ou Villa, le champ est obligatoire
																if (!value || value === 0) {
																	return Promise.reject(new Error('Une résidence est obligatoire.'));
																}
															}

															return Promise.resolve();
														}
													}
												]}
											>
												<BuildingSelector
													onChange={handleChangeBuilding}
												/>
											</Form.Item>
										</FloatLabel>
									</Col>
								</Row>
								<Row gutter={[10, 10]}>
									<Col xs={24}>
										<FloatLabel label="Villa" value={values.product_id}>
											<Form.Item
												style={{marginRight:0}}
												name="product_id"
												//rules={[{ required: true, message: "Un compte est obligatoire." }]}
											>
												<SelectLot
													apiEndPoint="search/product"
													onChange={handleChangeLot}
													onSelect={handleSelectLot}
												/>
											</Form.Item>
										</FloatLabel>
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
				</Col>
				<Col xs={24} md={12} >
					<Row gutter={[10, 10]}>
						<Col xs={24} >
						<Card title="Période loué" size="small" style={{width: '100%'}}>
							<Row gutter={[10, 10]}>
								{/*Input start_at*/}
								<Col xs={24} lg={12}>
									<FloatLabel label="Date début" value={values.start_at} >
										<Form.Item
											style={{marginRight:0}}
											name="start_at"
											rules={[{ required: true, message: "Une date est obligatoire." }]}
										>
											<DatePicker
												onChange={onDateChange('start_at')}
												format="DD/MM/YYYY"
												placeholder=""
											/>
										</Form.Item>
									</FloatLabel>
								</Col>

								{/*Input end_at*/}
								<Col xs={24} lg={12}>
									<FloatLabel label="Date fin" value={values.end_at} >
										<Form.Item
											style={{marginRight:0}}
											name="end_at"
											rules={[{ required: true, message: "Une date est obligatoire." }]}
										>
											<DatePicker
												format="DD/MM/YYYY"
												placeholder=""
											/>
										</Form.Item>
									</FloatLabel>
								</Col>
							</Row>
						</Card>
						</Col>

						<Col xs={24} >
						<Card title="Tarification & acompte" size="small" style={{width: '100%'}}>
							<Row gutter={[10, 10]}>
								{/*Input amount*/}
								<Col sm={24} lg={12}>
									<FloatLabel label="Montant séjour" value={values.price} >
										<Form.Item
											style={{marginRight:0, marginBottom:0}}
											name="price"
											rules={[
												/*{ required: true, message: "Un montant est obligatoire." },*/
												{
													validator: (_, value) => {
														if (!value || value === 0) {
															return Promise.reject(new Error('Un montant est obligatoire.'));
														}
														return Promise.resolve();
													}
												}
											]}
										>
											<InputNumberFormated
												style={{width: '100%'}}
												value={values.price}
											/>
										</Form.Item>
									</FloatLabel>
								</Col>

							</Row>
							{ !hasVilla() && ( // Residence
								<>
									<Divider type="horizontal" orientation="left" style={{margin: '10px 0'}}>Acompte Séjour</Divider>
									<Row gutter={[10, 10]}>
										{/*Input start_at*/}
										<Col xs={24} lg={12}>
											<FloatLabel label="Date acompte" value={values.deposit_at || dayjs()} >
												<Form.Item
													style={{marginRight:0}}
													name="deposit_at"
												>
													<DatePicker
														format="DD/MM/YYYY"
														placeholder=""
													/>
												</Form.Item>
											</FloatLabel>
										</Col>
										{/*Input amount*/}
										<Col sm={24} lg={12}>
											<FloatLabel label="Montant acompte" value={values.deposit_tenant} >
												<Form.Item
													style={{marginRight:0}}
													name="deposit_tenant"
													rules={[{ required: true, message: "Un acompte est obligatoire." }]}
												>
													<InputNumberFormated
														asZero={true}
														style={{width: '100%'}}
														value={values.deposit_tenant}
													/>
												</Form.Item>
											</FloatLabel>
										</Col>
									</Row>
								</>
							)}

							{ hasVilla() && ( // Villa
								<>
									<Divider type="horizontal" orientation="left" style={{margin: '10px 0'}}>Loyer Propriétaire</Divider>
									<Row gutter={[10, 10]}>
										<Col xs={24} lg={12}>
											<FloatLabel label="Montant loyer" value={values.deposit_owner} >
												<Form.Item
													style={{marginRight:0}}
													name="deposit_owner"
													dependencies={['price']}
													rules={[
														{
															validator: (_, value) => {
																if (hasVilla()) {
																	// Vérification si le champ est vide
																	if (!value || value === 0) {
																		return Promise.reject(new Error('Un montant est obligatoire.'));
																	}

																	// Récupération du prix du séjour depuis le formulaire
																	const price = form.getFieldValue('price');

																	// Vérification que le loyer n'est pas supérieur au prix du séjour
																	if (price && value > price) {
																		return Promise.reject(new Error('Le loyer propriétaire ne peut pas être supérieur au montant du séjour.'));
																	}
																}
																return Promise.resolve();
															}
														}
													]}
												>
													<InputNumberFormated
														style={{width: '100%'}}
														value={values.deposit_owner}
													/>
												</Form.Item>
											</FloatLabel>
										</Col>
									</Row>
								</>
							)}
						</Card>
						</Col>
						</Row>
				</Col>
			</Row>

				<Row gutter={[10, 10]} style={{ margin: '10px 0'}} justify="end">
					<Col>
						<Button size="large" type="primary" htmlType="submit">
							Valider
						</Button>
					</Col>
				</Row>
			</Form>
		</div>
	);
}
